import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const backdropDefaultVariants = {
  "status": "info",
  "elevation": "under"
}
const backdropCompoundVariants = []

const backdropSlotNames = [
  [
    "root",
    "backdrop__root"
  ]
]
const backdropSlotFns = /* @__PURE__ */ backdropSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, backdropDefaultVariants, getSlotCompoundVariant(backdropCompoundVariants, slotName))])

const backdropFn = memo((props = {}) => {
  return Object.fromEntries(backdropSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const backdropVariantKeys = [
  "size",
  "elevation",
  "status"
]
const getVariantProps = (variants) => ({ ...backdropDefaultVariants, ...compact(variants) })

export const backdrop = /* @__PURE__ */ Object.assign(backdropFn, {
  __recipe__: false,
  __name__: 'backdrop',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: backdropVariantKeys,
  variantMap: {
  "size": [
    "page",
    "element"
  ],
  "elevation": [
    "under",
    "raised"
  ],
  "status": [
    "fatal",
    "error",
    "warning",
    "info",
    "success"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, backdropVariantKeys)
  },
  getVariantProps
})